module.exports = __webpack_public_path__ + "img/charity.28e0ea11.png";